import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ManageUsers from './ManageUsers/ManageUsers'
import ManageUserDetail from './ManageUsers/ManageUserDetail'
import ManageFish from './ManageFish/ManageFish'
import ManageFishDetail from './ManageFish/ManageFishDetail'
import ManageFishRecipe from './ManageFish/ManageFishRecipe'
import ManageFishRecipeDetail from './ManageFish/ManageFishRecipeDetail'
import ManageArticleList from './ManageArticle/ManageArticleList'
import ManageArticleDetail from './ManageArticle/ManageArticleDetail'
import ManageEventList from './ManageEvent/ManageEventList'
import ManageEventDetail from './ManageEvent/ManageEventDetail'
import AddFish from './AddFish'
import AddReservation from './AddReservation'
import FishReservations from './FishReservations'
import FishReservationLog from './FishReservationLog'
import AddedFishList from './AddedFishList'

const MainRoutes = () => {
  return (
    <Switch>
      <Route exact path="/manageapp" component={ () => <div>Proszę coś wybrać</div>} />
      <Route path="/manageapp/manage-users" key="manage-users" component={ManageUsers} />
      <Route path="/manageapp/manage-restaurant" key="manage-restaurant" component={ManageUsers} />
      <Route path="/manageapp/manage-user-detail" component={ManageUserDetail} />
      <Route path="/manageapp/manage-fish" component={ManageFish} />
      <Route path="/manageapp/manage-fish-detail" component={ManageFishDetail} />
      <Route path="/manageapp/manage-fish-recipe" component={ManageFishRecipe} />
      <Route path="/manageapp/manage-fish-recipe-detail" component={ManageFishRecipeDetail} />
      <Route path="/manageapp/manage-article" component={ManageArticleList} />
      <Route path="/manageapp/manage-article-detail" component={ManageArticleDetail} />
      <Route path="/manageapp/manage-event" component={ManageEventList} />
      <Route path="/manageapp/manage-event-detail" component={ManageEventDetail} />
      <Route path="/manageapp/add-fish" component={AddFish} />
      <Route path="/manageapp/add-reservation" component={AddReservation} />
      <Route path="/manageapp/fish-reservations" component={FishReservations} />
      <Route path="/manageapp/fish-reservations-log" component={FishReservationLog} />
      <Route path="/manageapp/added-fish" component={AddedFishList} />
    </Switch>
  )
}

export default MainRoutes



// WEBPACK FOOTER //
// ./src/containers/MainRoutes.js